module.exports = __webpack_public_path__ + "img/HomeTrack_Icon_RGB.bc62424b.svg";